import { cn } from "@/lib/utils";

export function ShinyText({label}) {
  return (
    <div className="z-10 flex min-h-8 items-center justify-center">
      <div
        className={cn(
          "px-3 group rounded-full border border-black/5 bg-[#ed3237] text-base text-white transition-all ease-in hover:cursor-pointer hover:bg-[#ed3237]/90 dark:border-white/5 dark:bg-neutral-900 dark:hover:bg-neutral-800",
        )}
      >
          <span>✨ {label}</span>
      </div>
    </div>
  );
}
